export type FaqItem = { question: string; answer: string }

export type FaqCategory = {
  key: "trademark" | "design" | "patent"
  title: string
  image: string
  summary: string
  items: FaqItem[]
}

export const faqCategories: FaqCategory[] = [
  {
    key: "trademark",
    title: "Trademark",
    image: "/images/trademark.svg",
    summary:
      "Questions about EU trademark filing, applicant requirements, goods and services, fees and representation.",
    items: [
      {
        question: "Can I file an EU trademark if my company is outside Europe?",
        answer:
          "Yes. xpress-ip is specifically designed to make European trademark filing accessible to applicants and IP professionals outside Europe.",
      },
      {
        question: "Who represents my trademark application?",
        answer:
          "Your application is professionally represented before the EUIPO in cooperation with DANTZ IP & LAW.",
      },
      {
        question: "What information do I need to provide?",
        answer:
          "You need to provide applicant information, the trademark itself, the goods and services for which protection is sought and any relevant additional information or priority details.",
      },
      {
        question: "Do I need to prepare the application myself?",
        answer:
          "No. You provide the required information and documents online. xpress-ip prepares and submits the filing and handles the associated administrative process.",
      },
      {
        question: "How are the costs controlled?",
        answer:
          "The applicable costs are presented before filing. Official fees are paid after receipt of your payment. Additional cost-generating services are not performed automatically.",
      },
    ],
  },
  {
    key: "design",
    title: "Design",
    image: "/images/design.svg",
    summary:
      "Questions about EU design filing, design representations, classification, fees and registration.",
    items: [
      {
        question: "Can I file an EU design online?",
        answer:
          "Yes. You can provide your applicant information and upload your design representations through the xpress-ip platform.",
      },
      {
        question: "How many design views can I upload?",
        answer:
          "The current filing process allows up to 7 views or perspectives as specified in the application workflow.",
      },
      {
        question: "Who represents my design application?",
        answer:
          "Your application is filed with the EUIPO and professionally represented in cooperation with DANTZ IP & LAW.",
      },
      {
        question: "How are the costs controlled?",
        answer:
          "The applicable service fees and official fees are shown before filing. Official fees are paid after receipt of your payment.",
      },
    ],
  },
  {
    key: "patent",
    title: "Patent",
    image: "/images/patent.svg",
    summary:
      "Questions about European patent filing, patent specifications, inventors, fees and professional representation.",
    items: [
      {
        question: "Can I file a European patent through xpress-ip?",
        answer:
          "Yes. xpress-ip provides an online filing process for European patent applications.",
      },
      {
        question: "In which languages can the patent specification be submitted?",
        answer:
          "The xpress-ip application process accepts patent specifications in English, French or German.",
      },
      {
        question: "Who represents my application?",
        answer:
          "Your application is professionally represented before the European Patent Office in cooperation with DANTZ IP & LAW.",
      },
      {
        question: "What does the patent specification include?",
        answer:
          "The specification may include the description, the claims, the drawings and the summary of your invention.",
      },
    ],
  },
]

export const generalFaq: FaqItem[] = [
  {
    question: "How do I pay?",
    answer:
      "Depending on the service, payment can be made against an invoice or by credit card.",
  },
  {
    question: "When are official fees paid?",
    answer:
      "Official fees are paid after xpress-ip has received the corresponding payment from you.",
  },
  {
    question: "Will additional services be performed automatically?",
    answer:
      "No. xpress-ip does not automatically perform additional cost-generating services.",
  },
  {
    question: "How are deadlines handled?",
    answer:
      "Relevant deadlines are calculated and monitored, and you receive a reminder four weeks before the applicable deadline.",
  },
  {
    question: "Do I need a European representative?",
    answer:
      "If you are based outside the European Economic Area, professional representation requirements may apply. xpress-ip provides representation through DANTZ IP & LAW.",
  },
]
